import React from "react";
//component
import SwiperCarousel from "../Swiper/SwiperCarousel";
//mock data
import { items } from "../../mocks/slideData";

const Hero = () => {
  return (
    <div className="mb-44 bubble top-0 bg-gradient-0 h-full from-[#fab8c4b3] to-white items-center justify-center">
      {/* <div>
        <img
          src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-31.png"
          className="absolute top-32 opacity-90 right-96"
          alt=""
        />
      </div> */}
      {/* <div>
        <img
          src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-14.png"
          className="absolute top-96 opacity-90 left-56"
          alt=""
        />
      </div> */}
      <div className="flex flex-col items-center justify-center mb-44">
        <img
          src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-36.png"
          alt=""
          className="absolute top-0 left-0 h-32"
        />
        <h1 className="z-10 mt-20 text-center text-6xl font-bold">
          The Wall Of Frame
        </h1>
        <SwiperCarousel carouselData={items as any} />
      </div>
    </div>
  );
};

export default Hero;
